import { render } from "./ControlButton.vue?vue&type=template&id=d79ca6f6&scoped=true"
import script from "./ControlButton.vue?vue&type=script&lang=ts"
export * from "./ControlButton.vue?vue&type=script&lang=ts"

import "./ControlButton.vue?vue&type=style&index=0&id=d79ca6f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d79ca6f6"

export default script